import { connect } from "react-redux";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";

import LoadingContent from "@/components/common/LoadingContent";
import CreatingDemo from "@/components/company-pages/CreatingDemo";
import SwitchingCompany from "@/components/company-pages/SwitchingCompany";
import Accounting from "@/components/company-settings/accounting-tab/Accounting";
import Asset from "../components/assets/Asset";
import Assets from "../components/assets/Assets";
import Billing from "../components/billing/Billing";
import BillingEmails from "../components/billing/BillingEmails";
import BillingInformation from "../components/billing/BillingInformation";
import CompanyCreditHistory from "../components/billing/CreditHistory";
import ArchiveWrapper from "../components/common/ArchiveWrapper";
import SuspendedAccount from "../components/company-pages/SuspendedAccount";
import Settings from "../components/company-settings/Settings";
// import Dashboard from "../components/dashboard/Dashboard";
import { useEffect } from "react";
import Employee from "../components/employees/employee-page/Employee";
import Employees from "../components/employees/Employees";
import FSSExpress from "../components/fss-reports/FSSExpress";
import FssReports from "../components/fss-reports/FssReports";
import Submissions from "../components/fss-reports/Submissions";
import SetupChecklist from "../components/getting-started/SetupChecklist";
import Grades from "../components/grades/GradesPage";
import Leave from "../components/leave/LeavePage";
import PayrollHistory from "../components/payroll-history/PayrollHistory";
import PayslipHistory from "../components/payroll-history/PayslipHistory";
import Payroll from "../components/payroll/PayrollPage";
import Pension from "../components/pension/Pension";
import Permissions from "../components/permissions/Permissions";
import Report from "../components/report/Report";
import ReportBuilder from "../components/report/ReportBuilder";
import ViewTimesheets from "../components/timesheets/ViewTimesheets";
import WorkLocation from "../components/workLocation/WorkLocation";
import AutoEnrolmentReassessmentModal from "../components/pension/AutoEnrolmentReassessmentModal";

import CreateDemoCompany from "@/components/company-pages/CreateDemoCompany";
import NewEmployeeModal from "@/components/employees/modals/NewEmployeeModal";
import Notifications from "@/components/notifications/Notifications";
import { Actions as PERMISSION_ACTIONS } from "../store/actions/permissionActions";
import LeaveModal from "@/components/leave/LeaveModal";
import Dashboard from "@/components/dashboard/Dashboard";

const CompanyRouter = ({
	loading,
	creatingDemo,
	isSuspended,
	isArchived,
	isSetup,
	switchingCompany,
	getMyPermissions,
	jurisdiction,
	loaded,
	organisations,
	hasDemo,
	org,
}) => {
	useEffect(() => {
		if (loaded) getMyPermissions();
	}, [loaded]);

	const navigate = useNavigate();

	if (creatingDemo) return <CreatingDemo />;
	if (organisations?.length == 0 && !hasDemo) return <CreateDemoCompany />;
	if (switchingCompany) return <SwitchingCompany />;
	if (loading) {
		return (
			<LoadingContent
				style={{ height: "15vh", width: "15vh" }}
				className="animate-spin"
			/>
		);
	}
	if (!loaded && !org) navigate("/user/organisations");
	if (isSuspended) return <SuspendedAccount />;

	return (
		<>
			{isArchived && (
				<div>
					<div className="clearfix" />
					<ArchiveWrapper />
				</div>
			)}
			{["UK"].includes(jurisdiction) ? (
				/* Place any UK Specific Modals*/
				<AutoEnrolmentReassessmentModal />
			) : null}
			<NewEmployeeModal />
			<LeaveModal />
			<Routes>
				{isSetup ? (
					<Route
						path="setup"
						element={<SetupChecklist />}
					/>
				) : null}
				<Route
					path="/dashboard"
					element={<Dashboard />}
				/>
				{!isSuspended && (
					<>
						{!hasDemo && (
							<Route
								exact
								path="demo"
								element={<CreateDemoCompany />}
							/>
						)}
						<Route
							path="/notifications"
							element={<Notifications />}
						/>
						{/* <Route
							path="dashboard"
							element={<Dashboard />}
						/> */}

						<Route
							exact
							path="people/*"
							element={
								<Routes>
									<Route
										exact
										path="/"
										element={<Employees />}
									/>
									<Route
										path=":id/*"
										element={<Employee />}
									/>
								</Routes>
							}
						/>

						<Route
							path="grades"
							element={<Grades />}
						/>

						<Route
							path="payroll/:payPeriodId?/*"
							element={<Payroll />}
						/>

						<Route
							exact
							path="payroll-history/*"
							element={
								<Routes>
									<Route
										path="payslips"
										element={<PayslipHistory />}
									/>
									<Route
										path="*"
										element={<PayrollHistory />}
									/>
								</Routes>
							}
						/>

						<Route
							exact
							path="tax-forms/*"
							element={
								<Routes>
									<Route
										path="submission"
										element={<Submissions />}
									/>
									<Route
										path="*"
										element={<FssReports />}
									/>
								</Routes>
							}
						/>

						<Route
							exact
							path="reports/*"
							element={
								<Routes>
									<Route
										path=":id"
										element={<ReportBuilder />}
									/>
									<Route
										path="/"
										element={<Report />}
									/>
								</Routes>
							}
						/>

						{["UK"].includes(jurisdiction) ? (
							<>
								<Route
									path="pension/*"
									element={<Pension />}
								/>

								<Route
									path="asset/:id"
									element={<Asset />}
								/>
								<Route
									path="assets"
									element={<Assets />}
								/>
								<Route
									path="accounting/*"
									element={<Accounting />}
								/>
							</>
						) : null}

						<Route
							path="timesheets"
							element={<ViewTimesheets />}
						/>
						<Route
							path="leave/*"
							element={<Leave />}
						/>
						<Route
							path="work-locations/"
							element={<WorkLocation />}
						/>

						<Route
							path="settings/*"
							element={<Settings />}
						/>
						<Route
							path="permissions"
							element={<Permissions />}
						/>
						<Route
							path="fss-xpress"
							element={<FSSExpress />}
						/>
						<Route
							path="billing/*"
							element={
								<div className="mb-32">
									<Billing />
									<Routes>
										<Route
											path="/"
											element={<BillingInformation />}
										/>
										<Route
											path="/credit-history"
											element={<CompanyCreditHistory />}
										/>
										<Route
											path="emails"
											element={<BillingEmails />}
										/>
										<Route
											path="*"
											element={
												<Navigate
													to="/billing"
													replace
												/>
											}
										/>
									</Routes>
								</div>
							}
						/>
					</>
				)}
				<Route
					path="*"
					element={
						<Navigate
							to="/people"
							replace
						/>
					}
				/>
			</Routes>
		</>
	);
};

const mapStateToProps = (state) => {
	const { settings: company, loading } = state.company || {};
	const { status, isDemo, org, jurisdiction } = company || {};

	return {
		organisations: state.organisations?.filter((organisation) => !organisation.isDemo),
		hasDemo: state.organisations?.find((organisation) => organisation.isDemo),
		isDemo,
		isSetup: status === "Setup",
		isSuspended: status === "Suspended",
		isArchived: status === "Archived",
		switchingCompany: state.switchingCompany,
		loading,
		jurisdiction,
		creatingDemo: state.creatingDemo,
		loaded: org && !loading,
		org,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getMyPermissions: () => dispatch(PERMISSION_ACTIONS.getMyPermissions()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CompanyRouter);
